export const PERMANENT_HOME_OTHER_MAX = 100;

export const GM_PERMANENT_HOME_OPTIONS = [
  'Parent 1',
  'Parent 2',
  'Both Parents',
  'Legal Guardian',
  'Other',
] as const;

export const COMMON_APP_PERMANENT_HOME_OPTIONS = [
  'Parent 1',
  'Parent 2',
  'Both Parents',
  'Other',
] as const;

const LEGACY_TO_GM: Record<string, string> = {
  'Both Parents/Guardians': 'Both Parents',
  'Parent/Guardian 1': 'Parent 1',
  'Parent/Guardian 2': 'Parent 2',
  'Ward of Court/State': 'Other',
  'Ward of the Court': 'Other',
  'Ward of the court': 'Other',
};

const OTHER_TEXT_FOR_VALUE: Record<string, string> = {
  'Legal Guardian': 'Legal Guardian',
  'Ward of Court/State': 'Ward of the court',
  'Ward of the Court': 'Ward of the court',
  'Ward of the court': 'Ward of the court',
};

const clipOtherText = (value?: string) => `${value ?? ''}`.trim().slice(0, PERMANENT_HOME_OTHER_MAX);

export const isLegalGuardianHome = (whom?: string) =>
  whom === 'Legal Guardian' || whom === 'Ward of Court/State';

export const normalizePermanentHome = (whom?: string, otherText?: string) => {
  const raw = `${whom ?? ''}`.trim();
  const currentOther = clipOtherText(otherText);
  const mapped = LEGACY_TO_GM[raw] ?? raw;

  if (mapped === 'Legal Guardian' || raw === 'Legal Guardian') {
    return {
      whom_live_permanently: 'Legal Guardian',
      other_live_with_free_text: currentOther || OTHER_TEXT_FOR_VALUE['Legal Guardian'],
    };
  }

  if (mapped === 'Other') {
    return {
      whom_live_permanently: 'Other',
      other_live_with_free_text: currentOther || OTHER_TEXT_FOR_VALUE[raw] || '',
    };
  }

  return {
    whom_live_permanently: mapped,
    other_live_with_free_text: '',
  };
};

export const toCommonAppPermanentHome = (whom?: string, otherText?: string) => {
  const normalized = normalizePermanentHome(whom, otherText);
  if (normalized.whom_live_permanently === 'Legal Guardian') {
    return {
      permanent_home: 'Other',
      permanent_home_other_text:
        normalized.other_live_with_free_text || OTHER_TEXT_FOR_VALUE['Legal Guardian'],
    };
  }
  return {
    permanent_home: normalized.whom_live_permanently,
    permanent_home_other_text: normalized.whom_live_permanently === 'Other'
      ? normalized.other_live_with_free_text
      : '',
  };
};
